import Ajax from "Utils/ajax";
export const getAllCompanyList = (data) => Ajax.post('hr/getAllCompanyList',data); 
export const getStaffList = (data) => Ajax.post('hr/getAllStaff',data);
export const bulkAttendance = (data) => Ajax.post('hr/bulkAttendance',data);